module.exports = __webpack_public_path__ + "img/alipay.13ef4bff.svg";